import { formatToUTCWithoutOffset } from 'common/helpers/timeHelpers';

export function checkAndUpdateTime(time: string, dateTimeFormat: string) {
  const currentTime = checkAndUpdateTimeValidity(time);
  return formatToUTCWithoutOffset(currentTime, dateTimeFormat);
}

export function checkAndUpdateTimeValidity(time: string) {
  // In cases where we don't have date/time delimiter (there are cases which have blank space) we need to add it manually
  let currentTime = time?.replace(' ', 'T');
  // All datetimes we receive are in UTC but can happen in different formats so cases which doesn't finish with timezone
  // suffix we need to format manually
  const isDateWithTimeZone = currentTime.endsWith('Z');
  if (!isDateWithTimeZone) {
    currentTime = `${currentTime}Z`;
  }
  return currentTime;
}
